import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LOYALTY_URL_PARAM } from '../../../utils/constants';
import { selectIsLoyaltyFilterChecked, setIsLoyaltyFilterChecked } from '../../../core/reducers/specialOffers';
import { useAppDispatch, useAppSelector } from '../../../core/utils';
const useLoyaltyOfferFilter = () => {
    const { search } = useLocation();
    const dispatch = useAppDispatch();
    const [canShowLoyaltyFilter, setCanShowLoyaltyFilter] = useState(false);
    const isFilterChecked = useAppSelector(selectIsLoyaltyFilterChecked);
    const decodedQueryString = decodeURIComponent(search);
    const searchParams = useMemo(() => new URLSearchParams(decodedQueryString), [decodedQueryString]);
    /*
     Due to serverSide rendering we are forced to make sure the useEffect content runs after hydration.
     To give the required effect
    */
    useEffect(() => {
        setCanShowLoyaltyFilter(searchParams.get(LOYALTY_URL_PARAM) === 'true');
    }, [searchParams]);
    const toggleLoyaltyFilter = useCallback(() => dispatch(setIsLoyaltyFilterChecked(!isFilterChecked)), [dispatch, isFilterChecked]);
    return { isFilterChecked, toggleLoyaltyFilter, canShowLoyaltyFilter };
};
export default useLoyaltyOfferFilter;
